<template>
  <div>
    <b-card>
      <b-container fluid>
        <b-form @submit.prevent="applySearch">
          <b-row>
            <b-col
              v-if="filterByKey == 'user_id'"
              md="4"
            >
              <label for="states">Search by state</label>
              <v-select
                id="states"
                v-model="currState"
                placeholder="No state selected"
                :options="stateOptions"
                label="label"
                :reduce="(option) => option.key"
                @input="applySearch"
              />
            </b-col>
            <b-col
              v-if="filterByKey == 'user_id'"
              md="4"
            >
              <label for="user">Search by User Phone number</label>
              <b-form-input
                id="user"
                v-model="queryParams.user_phone"
                type="number"
                placeholder="User Phone number"
              />
            </b-col>

            <b-col
              v-if="filterByKey == 'user_id'"
              md="4"
            >
              <label for="trip">Search by trip number</label>
              <b-form-input
                id="trip"
                v-model="tripId"
                type="number"
                placeholder="Trip number"
              />
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col
              md="4"
            >
              <label for="date1">From Date</label>
              <b-form-datepicker
                id="date1"
                v-model="dateTimeFilter.fromDate"
              />
              <label
                class="mt-1"
              >
                From Time</label>
              <b-input-group>
                <flat-pickr
                  v-model="dateTimeFilter.fromTime"
                  class="form-control"
                  :config="{ enableTime: true, noCalendar: true, time_24hr: true}"
                />
                <b-input-group-append>
                  <b-button
                    v-if="dateTimeFilter.fromTime"
                    class="btn-icon"
                    variant="primary"
                    @click="dateTimeFilter.fromTime = ''"
                  >
                    <feather-icon icon="XIcon" />
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col
              md="4"
            >
              <label for="date2">To Date</label>
              <b-form-datepicker
                id="date2"
                v-model="dateTimeFilter.toDate"
              />
              <label
                class="mt-1"
                for="time2"
              >To Time</label>
              <b-input-group>
                <flat-pickr
                  v-model="dateTimeFilter.toTime"
                  class="form-control"
                  :config="{ enableTime: true, noCalendar: true, time_24hr: true}"
                />
                <b-input-group-append>
                  <b-button
                    v-if="dateTimeFilter.toTime"
                    class="btn-icon"
                    variant="primary"
                    @click="dateTimeFilter.toTime = ''"
                  >
                    <feather-icon icon="XIcon" />
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col md="4">
              <template
                v-if="filterByKey == 'user_id'"
              >
                <label
                  for="driver"
                >Search by Driver Phone number</label>
                <b-form-input
                  id="driver"
                  v-model="queryParams.driver_phone"
                  type="number"
                  placeholder="Driver Phone number"
                />
              </template>
              <template v-if="filterByKey == 'business_id'">
                <label for="promo-code">Search by promo code</label>
                <b-form-input
                  id="promo-code"
                  v-model="queryParams.promo"
                  placeholder="Promo Code"
                />
              </template>
              <template v-if="filterByKey == 'business_id'">
                <label for="user">Search by User Phone number</label>
                <b-form-input
                  id="user"
                  v-model="queryParams.user_phone"
                  type="number"
                  placeholder="User Phone number"
                />
              </template>

              <div class="mt-2 d-flex justify-content-between align-items-end">
                <b-button
                  variant="primary"
                  type="submit"
                >
                  Search
                </b-button>
                <b-button
                  variant="outline-primary"
                  @click="clearFilter"
                >
                  Clear
                </b-button>
                <b-button
                  class="btn-icon rounded-circle ml-1"
                  variant="flat-primary"
                  type="submit"
                >
                  <feather-icon
                    icon="RefreshCwIcon"
                  />
                </b-button>
                <h6>
                  Total: {{ totalTrips }}
                </h6>
              </div>
            </b-col>

          </b-row>
        </b-form>
      </b-container>
      <b-overlay
        variant="white"
        spinner-variant="primary"
        blur="0"
        opacity=".75"
        rounded="sm"
        :show="loading"
      >
        <b-table
          :fields="tableColumns"
          :items="tripsList"
          hover
          striped
          show-empty
          empty-text="No matching trips found"
          class="text-center"
          @row-clicked="redirectToTripDetails"
        >
          <template #cell(state)="data">
            <trip-status-badge :status="data.item.state" />
          </template>
        </b-table>
        <base-pagination
          v-model="queryParams.page"
          :total="totalTrips"
          @input="fetchTripsList"
          @new-per-page="queryParams.perPage = $event"
        />
      </b-overlay></b-card>
  </div>
</template>

<script>
import {
  BTable, BCard, BOverlay, BFormDatepicker, BContainer, BRow, BCol, BButton, BFormInput, BForm,
  BInputGroup, BInputGroupAppend,
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import vSelect from 'vue-select'
import {
  reactive, ref, toRef, watch,
} from '@vue/composition-api'
  // import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
  // import tripsStore from '@/views/trips/store'
  // import store from '@/views/driver-user-shared/driver-user-trips/store'
import tripStatusBadge from '@/views/trips/components/TripStatusBadge.vue'
import BasePagination from '@/UI/BasePagination.vue'
import { formatDate } from '@/@core/utils/filter'
import { tripStatusFormatter } from '@/views/trips/hooks/tripStatusUtils'
import { errorNotification } from '@/utils/toast-notifications'
import axiosIns from '@/libs/axios'

export default {
  components: {
    flatPickr,
    BTable,
    BCard,
    BOverlay,
    tripStatusBadge,
    BasePagination,
    vSelect,
    BFormDatepicker,
    BContainer,
    BForm,
    BRow,
    BCol,
    BButton,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
  },
  props: {
    filterByKey: {
      type: String,
      required: true,
    },
    filterByValue: {
      type: String,
      required: true,
    },
  },
  setup(props, ctx) {
    // useRegisterStoreModule('trips', tripsStore)
    const redirectToTripDetails = $event => {
      const r = ctx.root.$router.resolve(`/trips/${$event.id}`)
      window.open(r.href, '_blank')
    }

    const loading = ref(false)
    const tableColumns = [
      { key: 'number', label: 'trip number' },
      {
        key: 'createdAt',
        label: 'created at',
        formatter: value => formatDate(value),
      },
      {
        label: 'Rider',
        key: 'userDetails',
        formatter: val => `${val?.first_name} ${val?.last_name}`,
      },
      {
        label: 'Driver',
        key: 'driver',
        formatter: val => val && `${val.first_name} ${val.last_name}`,
      },
      {
        label: 'Driver id',
        key: 'driverId',
      },
      {
        label: 'Zone',
        key: 'zone',
        formatter: val => val?.split('::')[1],
      },
      {
        label: 'Type',
        key: 'className',
      },
      {
        label: 'status',
        key: 'state',
        formatter: val => tripStatusFormatter(val),
      },
    ]

    const stateOptions = [
      {
        label: 'All',
        key: 'ALL',
      },
      {
        label: 'Completed',
        key: 'COMPLETED',
      },
      {
        label: 'Created',
        key: 'CREATED',
      },
      {
        label: 'Canceled',
        key: 'CANCELED',
      },
      {
        label: 'Accepted',
        key: 'ACCEPTED',
      },
      {
        label: 'Arrived',
        key: 'ARRIVED',
      },
      {
        label: 'In progress',
        key: 'IN_PROGRESS',
      },
      {
        label: 'Looking for driver',
        key: 'LOOKING_FOR_DRIVER',
      },
      {
        label: 'No driver found',
        key: 'NO_DRIVER_FOUND',
      },
    ]
    const tripsList = ref([])
    const totalTrips = ref(0)
    const tempTime = new Date()

    const dateTimeFilter = reactive({
      fromDate: `${tempTime.getFullYear()}-${tempTime.getMonth() + 1}-${tempTime.getDate()}`,
      fromTime: undefined,
      toDate: `${tempTime.getFullYear()}-${tempTime.getMonth() + 1}-${tempTime.getDate()}`,
      toTime: undefined,
    })
    const tripId = ref()
    const queryParams = reactive({
      size: 10,
      page: 1,
      state: undefined,
      promo: undefined,
      user_phone: undefined,
      driver_phone: undefined,
      trip_id: undefined,
      [props.filterByKey]: props.filterByValue,
    })
    const currState = ref('ALL')
    // const filterUserNumber = ref('')
    const setFilterDateFormat = () => {
      if (dateTimeFilter.fromDate) {
        if (!dateTimeFilter.fromTime) {
          queryParams.from = new Date(`${dateTimeFilter.fromDate} 00:00:00`)
        } else {
          queryParams.from = new Date(`${dateTimeFilter.fromDate} ${dateTimeFilter.fromTime}`)
        }
      }
      if (dateTimeFilter.toDate) {
        if (dateTimeFilter.fromDate) {
          if (!dateTimeFilter.toTime) {
            const now = new Date()
            queryParams.to = new Date(`${dateTimeFilter.toDate} ${now.getHours()}:${now.getMinutes()}:${now.getSeconds()}`)
          } else {
            queryParams.to = new Date(`${dateTimeFilter.toDate} ${dateTimeFilter.toTime}`)
          }
          return true
        }
        errorNotification('You should fill the from date and time first')
        return false
      }
      return true
    }

    const fetchTripsList = async () => {
      try {
        const val = setFilterDateFormat()
        if (!val) return
        loading.value = true
        if (currState.value === 'ALL') {
          queryParams.state = undefined
        } else {
          queryParams.state = currState.value
        }
        if (tripId.value) {
          queryParams.trip_id = tripId.value
        } else {
          queryParams.trip_id = undefined
        }
        const res = await axiosIns.get('/trips', {
          params: queryParams,
        })
        const { trips, total } = res.data.data
        tripsList.value = trips.map(trip => ({
          ...trip,
          driverId: trip.driver ? trip.driver.driver_id : undefined,
        }))
        totalTrips.value = total
      } catch (error) {
        console.log(error)
      } finally {
        loading.value = false
      }
    }
    const applySearch = () => {
      queryParams.page = 1
      fetchTripsList()
    }
    const clearFilter = () => {
      currState.value = 'ALL'
      queryParams.state = undefined
      dateTimeFilter.fromDate = undefined
      dateTimeFilter.toDate = undefined
      dateTimeFilter.fromTime = undefined
      dateTimeFilter.toTime = undefined
      queryParams.promo = undefined
      queryParams.from = undefined
      queryParams.driver_phone = undefined
      queryParams.user_phone = undefined
      queryParams.to = undefined
      queryParams.trip_id = undefined
      tripId.value = undefined
      fetchTripsList()
    }
    fetchTripsList()
    watch([toRef(queryParams, 'size')], () => {
      fetchTripsList()
    })
    // const canSearch = computed(() => filterUserNumber.value || tripId.value)
    return {
      // canSearch,
      applySearch,
      tableColumns,
      fetchTripsList,
      tripsList,
      loading,
      totalTrips,
      stateOptions,
      queryParams,
      redirectToTripDetails,
      dateTimeFilter,
      clearFilter,
      currState,
      //   filterUserNumber,
      tripId,
    }
  },

}
</script>

    <style>

    </style>
